module.exports = __webpack_public_path__ + "static/media/logo.60cfaa92.svg";